

exports.__esModule = true;
exports.$xoPageAddCardPageComponent = undefined;

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('xo-wallet-components/src/add-card/directive');

require('xo-validation/dist/directive');

require('xo-ui-components/src/tooltip/directive');

require('xo-ui-components/src/dropdown/directive');

require('xo-page-components/src/value-props/directive');

require('xo-models/src/fi/lib/fiMessages');

require('xo-models/src/checkout/index');

var _squid = require('squid');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoPageAddCardPageComponent = exports.$xoPageAddCardPageComponent = _squid.$Component.extend('$xoPageAddCardPageComponent', {
    tag: 'xo-page-add-card-page',
    template: _template2['default'],
    scope: {},

    controller: function controller($scope, $rootScope, $state, $locale, $CheckoutSessionModel, $populate, $stateParams, $CheckoutPayeeModel, $fiMessages) {
        // eslint-disable-line max-params,no-shadow
        $scope.token = $rootScope.token;
        $scope.locale = $locale;
        $scope.callbacks = {
            finish: function finish() {
                $state.go('checkout.review');
            }
        };

        var models = {};

        $populate(models, {
            checkoutSession: $CheckoutSessionModel.instance($scope.token).retrieve({
                contingencies: {
                    NEED_CREDIT_CARD: angular.noop,
                    EXPIRED_CREDIT_CARD: angular.noop
                }
            }),
            payee: $CheckoutPayeeModel.instance($scope.token)
        }).then(function () {

            var message = $fiMessages.processorDeclinedMsg(models.checkoutSession, false) || $fiMessages.errorMsg(models.payee.isGambling());

            $scope.message = {
                type: 'info',
                msgs: [message.msg]
            };
        });
    }
});

angular.value("$xoPageAddCardPageComponent", $xoPageAddCardPageComponent);
_squid.$Component;


/*****************
 ** WEBPACK FOOTER
 ** ./pages/xo-add-card/directive.js
 ** module id = 389
 ** module chunks = 1
 **/